import React, { useEffect, useContext } from 'react';
import PropType from 'prop-types';
import './WelcomeTooltip.css';
import DragToRotateTooltip from '../DragToRotateTooltip/DragToRotateTooltip';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import { Button } from 'web-store-modules/packages/web-store-ui-library';
import { EnterButtonClicked } from '../../../../utils/Analytics';
import { ThreeJSWorldContext } from 'web-store-modules/packages/web-store-three-world';

const browseImg = 'https://cdn.obsess-vr.com/ferragamo/welcome/welcome-mousee.gif';
const productImg = 'https://cdn.obsess-vr.com/vacheron/product_welcome.svg';
const beautyImg = "https://cdn.obsess-vr.com/ferragamo/welcome/hotspot.svg";
const exploreImg = 'https://cdn.obsess-vr.com/vacheron/Group 2641.svg';
const handDragIcon = 'https://cdn.obsess-vr.com/vacheron/drag-tooltip-mobile.gif';
const isMobile = isMobileDevice();
const desktopTooltip = !isMobile ? {top:'0%'} : {};
const buttonWidth = isMobile ? '240px' : '210px';


const WelcomeTooltip = (props) => {
    const { welcomeMessageStyle, children, showBroseTooltip, showProductTooltip, showBeautyTooltip, isVisible,
        storeId, showMobileTooltip, isMobile, onWelcomeHide } = props;
    const tooltipClass = !isVisible ? 'tooltip-fadeout' : ''

    const threeJSWorldContext = useContext(ThreeJSWorldContext)

    const onModalHidden = () => {
        const targetPath = '/exterior-2';
        if (threeJSWorldContext.history.location.pathname !== targetPath) {
            threeJSWorldContext.pushHistoryWithReset(targetPath)
        }
        EnterButtonClicked();
        onWelcomeHide();
    }

    useEffect(() => {
        document.getElementById('welcome-overlay').addEventListener('click', onModalHidden);

        () => {
            document.getElementById('welcome-overlay').removeEventListener('click', onModalHidden);
        }
    } , [])

    return (
        <div id="tooltip-container" className={tooltipClass}>
            <div id="tooltip-component-container" className="flex-center">
                <div className="tooltip-row">
                    <div className="tooltip-col fadeInTooltip" >
                        <DragToRotateTooltip isTemplate image={isMobile  ? handDragIcon : browseImg} classes={'tooltip-first-img'} />
                        <div className='flexColumn'>
                            <h3>{'Browse'}</h3>
                            <span className="tooltip-message" id="tooltip-message">
                                {'Click and drag the screen or use arrows on the floor to explore.'}
                            </span>
                        </div>
                    </div>
                    <div className={'tooltip-col ' + (showProductTooltip ? 'fadeInTooltip' : '')}>
                        {showProductTooltip && <><DragToRotateTooltip isTemplate image={productImg} /> 
                            <div className='flexColumn'>
                                <h3>{`Product`}</h3>
                                <span className="tooltip-message" id="tooltip-message">
                                    {`Click on the icon to see product details and book an appointment to meet with a sales associate.`}
                                </span>
                            </div></>}
                    </div>
                    <div className={'tooltip-col ' + (showBeautyTooltip ? 'fadeInTooltip' : '')}>
                        {showBeautyTooltip && <><DragToRotateTooltip  isTemplate image={exploreImg} classes={'star exploreIcon'} />
                            <div className='flexColumn'>
                                <h3>{'Discover'}</h3>
                                <span className="tooltip-message" id="tooltip-message">
                                    {'Click on the icon to view exclusive content and more information about our watch collections.'}
                                </span>
                            </div>
                        </>}
                    </div>
                </div>
                <Button
                    hoverStyleChange={false}
                    primaryColor='#7C2529'
                    secondaryColor='#7C2529'
                    className="product-button flex-center obsessvr-regularFont full-width pointer exploreNowBtn"
                    style={{ padding: '0', borderRadius: '0px', width: buttonWidth,pointerEvents: 'all' }}
                    primaryBorderColor={"#7C2529"}
                    secondaryBorderColor={"#7C2529"}
                    insetBorder={true}
                    padded={false}
                >
                    <span className='obsessvr-regularFont ' style={{color:'#FFFFFF',fontSize: '18px',fontFamily: 'Prelo Medium'}}>
                        {`ENTER`}
                    </span>
                </Button>
                {children}
            </div>
        </div>
    );
};

WelcomeTooltip.propTypes = {
    welcomeMessageStyle: PropType.object,
    showBroseTooltip: PropType.bool,
    showBeautyTooltip: PropType.bool,
    showProductTooltip: PropType.bool,
};

export default WelcomeTooltip;
